(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/inputv2.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/inputv2.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => ( inputv2)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_React_namespaceObject = window["React"];
  var external_React_default = __webpack_require__.n(external_React_namespaceObject);
  ; 
  const external_svs_ui_ReactIcon_namespaceObject = window["svs"]["ui"]["ReactIcon"];
  var external_svs_ui_ReactIcon_default = __webpack_require__.n(external_svs_ui_ReactIcon_namespaceObject);
  ; 
  const _excluded = ["autoCapitalize", "autoComplete", "className", "hasFormData", "id", "inputHelpText", "inverted", "label", "multiline", "selectOnFocus", "onFocus", "prefix", "suffix", "size", "refElem", "isSmall", "showPassword"];
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }

  const Inputv2 = _ref => {
    let {
        autoCapitalize,
        autoComplete,
        className,
        hasFormData,
        id,
        inputHelpText,
        inverted,
        label,
        multiline,
        selectOnFocus,
        onFocus,
        prefix,
        suffix,
        size,
        refElem,
        isSmall,
        showPassword
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    const inputWrapper = external_React_default().useRef(null);
    const eyeIcon = external_React_default().useRef(null);
    const [showPwd, setPwdVisibility] = external_React_default().useState(showPassword);
    const handleToggle = () => {
      if (props.onClick) {
        props.onClick();
      }
      if (props.type === 'password') {
        if (showPwd) {
          inputWrapper.current.querySelector('.js-standard-input').type = 'text';
        } else {
          inputWrapper.current.querySelector('.js-standard-input').type = 'password';
        }
        setPwdVisibility(!showPwd);
      }
    };
    const classes = ['input-control'];
    const inputClasses = ['js-standard-input standard-input'];
    const inputProps = _objectSpread(_objectSpread({}, props), selectOnFocus ? {
      onFocus: event => {
        event.target.select();
        onFocus && onFocus(event);
      }
    } : {
      onFocus: event => {
        onFocus && onFocus(event);
      }
    });
    if (inverted) {
      classes.push('input-control-inverted');
    } else {
      classes.push('input-control-default');
    }
    if (prefix) {
      inputClasses.push('input-has-prefix');
    }
    if (className) {
      inputClasses.push(className);
      classes.push(className);
    }
    if (multiline) {
      classes.push('input-control-textarea');
    }
    if (inputProps.value) {
      inputClasses.push('input-valid');
    }
    let inputField;
    if (multiline) {
      inputField = external_React_default().createElement("textarea", _extends({
        "aria-label": "".concat(label).concat(inputHelpText ? ", - ".concat(inputHelpText) : ''),
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        className: inputClasses.join(' '),
        cols: inputProps.cols ? inputProps.cols : '1',
        id: id,
        ref: refElem,
        rows: inputProps.rows ? inputProps.rows : '1'
      }, inputProps));
    } else {
      inputField = external_React_default().createElement("input", _extends({
        "aria-label": "".concat(label).concat(inputHelpText ? ", - ".concat(inputHelpText) : ''),
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        className: inputClasses.join(' '),
        id: id,
        ref: refElem,
        value: inputProps.value
      }, inputProps));
    }
    const setSuffixWidth = input => {
      input = input.querySelector('.js-standard-input');
      const sufxEl = input.nextElementSibling.querySelector('.input-sufx');
      if (input.style.width.length === 0) {
        input.style.width = input.clientWidth > 0 ? "".concat(input.clientWidth - input.nextElementSibling.querySelector('.input-trailing').clientWidth, "px") : "calc(100% - 40px)";
      }
      if (inputProps.type === 'password') {
        sufxEl.style.cursor = 'pointer';
      }
    };
    const setPrefixWidth = input => {
      input = input.querySelector('.js-standard-input');
      const inputLabel = input.nextElementSibling.querySelector('.original-label');

      if (inputLabel.style.textIndent.length === 0) {
        inputLabel.style.textIndent = "".concat(!input.value.length ? input.nextElementSibling.querySelector('.input-prefx').clientWidth : 0, "px");
      }
      if (input.style.paddingLeft.length === 0) {
        input.style.paddingLeft = "".concat(input.nextElementSibling.querySelector('.input-prefx').clientWidth + 18, "px");
      }
    };
    external_React_default().useEffect(() => {
      if (suffix) {
        setSuffixWidth(inputWrapper.current);
      }
      if (prefix) {
        setPrefixWidth(inputWrapper.current);
      }
    });
    if (inputProps.type === 'password') {
      suffix = external_React_default().createElement(external_svs_ui_ReactIcon_default(), {
        color: inverted ? 'fc-white' : 'fc-navy',
        icon: showPwd ? 'eye-closed' : 'eye',
        size: "200"
      });
    }
    return external_React_default().createElement("div", {
      className: classes.join(' '),
      ref: inputWrapper
    }, inputField, external_React_default().createElement("div", {
      className: "input-look ".concat(inputProps.disabled ? 'input-look-disabled' : '')
    }, external_React_default().createElement("div", {
      className: "input-leading ".concat(prefix ? 'input-leading-has-prefix' : '')
    }, external_React_default().createElement("div", {
      className: "input-prefx"
    }, prefix)), external_React_default().createElement("div", {
      className: "input-notch"
    }, external_React_default().createElement("div", {
      className: "input-north-notch"
    }, external_React_default().createElement("label", {
      "aria-hidden": "true",
      className: "forms-label js-label-".concat(id, " ").concat(inputProps.value ? 'hide-label' : ''),
      htmlFor: id
    }, external_React_default().createElement("span", {
      className: "original-label"
    }, label), external_React_default().createElement("span", {
      className: "help-text-label"
    }, inputHelpText ? inputHelpText : label))), external_React_default().createElement("div", {
      className: "input-south-notch"
    })), external_React_default().createElement("div", {
      className: "standard-input-middle"
    }), external_React_default().createElement("div", {
      className: "input-trailing",
      onClick: handleToggle,
      ref: eyeIcon
    }, external_React_default().createElement("div", {
      className: "input-sufx"
    }, suffix))));
  };
  Inputv2.propTypes = {
    autoCapitalize: external_PropTypes_default().string,
    autoComplete: external_PropTypes_default().string,
    className: external_PropTypes_default().string,
    hasFormData: external_PropTypes_default().bool,
    id: external_PropTypes_default().string,
    inputHelpText: external_PropTypes_default().string,
    inverted: external_PropTypes_default().bool,
    isSmall: external_PropTypes_default().bool,
    label: external_PropTypes_default().string,
    multiline: external_PropTypes_default().bool,
    onClick: external_PropTypes_default().func,
    onFocus: external_PropTypes_default().func,
    prefix: external_PropTypes_default().node,
    refElem: external_PropTypes_default().oneOfType([external_PropTypes_default().object, external_PropTypes_default().func]),
    selectOnFocus: external_PropTypes_default().bool,
    showPassword: external_PropTypes_default().bool,
    size: external_PropTypes_default().string,
    suffix: external_PropTypes_default().node,
    type: external_PropTypes_default().string,
    value: external_PropTypes_default().oneOfType([external_PropTypes_default().number, external_PropTypes_default().string]).isRequired
  };
  Inputv2.defaultProps = {
    autoCapitalize: 'off',
    autoComplete: 'on',
    className: '',
    hasFormData: false,
    isSmall: false,
    prefix: null,
    refElem: null,
    selectOnFocus: true,
    showPassword: true,
    suffix: null
  };
  Inputv2.__docgenInfo = {
    "description": "Text input allows the user to freely input text. If appropriate allowed input can be restricted to for example only numerical characters or a limited number of characters. If the input required is limited to discrete smaller amount of options, a dropdown (components select & dropdown) can be considered a better option.\n\n## Label\nBefore interaction the input-field is occupied by a placeholder label describing the expected input from the user, e.g. in the case of a field where the user defines an amount to be withdrawn from SvS balance the label could read \u201CAnge belopp\u201D.\n\n## Input-help-text\nWhen text-input is focused the cursor takes the position of the placeholder, and the label is moved up to the upper edge of the frame. The label can remain as is after the transition, or label can be replaced by input-help-text in the focus state. Input-help-text is used to help guide the user to provide input in the expected format, e.g. if a numerical value is expected or maximum number of characters allowed.\n\n## Explanation\nIf further explanation is required in order to guide the user, the explanation field can be utilized. This text field is static and will not change during interaction with the text field, which can be useful for providing guidance prior to the user interacting with the text field.\n\n## Suffix\nText-input allows for adding a suffix at the end of the input field. The principle use case for this function is adding \u201Ckr\u201D in a text field where a monetary value is the expected input.\n\n## Icon\nText-input supports an icon at the right end of the text field, which is only used for password fields, where an eye icon acts as a button for showing / hiding the contents of a password field.\n\n## Disabled state\nIf the input field should not allow for interaction, e.g. if a prior input is required before allowing input, the input field can be made disabled and non-interactable.\n\n## Error\nIf an erroneous input is encountered the input field will enter the error state, with the underline turning red and an error-message describing the error and if possible, how to fix it. Ideally the user should be provided enough guidance prior in order to avoid encountering an error.\n\n## Inverted\nIf text-input is placed against a darker background the inverted version of the component should be used.\n\n## Multi-line\nIn cases where the expected input is a longer message the text field can be made multiline which will allow for multiple lines of input. In other regards, multiline text-input behaves similarly to the default component, including error states, etc.",
    "methods": [],
    "displayName": "Inputv2",
    "props": {
      "autoCapitalize": {
        "defaultValue": {
          "value": "'off'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "autoComplete": {
        "defaultValue": {
          "value": "'on'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "className": {
        "defaultValue": {
          "value": "''",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "hasFormData": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "isSmall": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "prefix": {
        "defaultValue": {
          "value": "null",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "refElem": {
        "defaultValue": {
          "value": "null",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "func"
          }]
        },
        "required": false
      },
      "selectOnFocus": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "showPassword": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "suffix": {
        "defaultValue": {
          "value": "null",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inputHelpText": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inverted": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "label": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "multiline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "onClick": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onFocus": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "size": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "type": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "number"
          }, {
            "name": "string"
          }]
        },
        "required": true
      }
    }
  };
  const inputv2 = Inputv2;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Inputv2 = __webpack_exports__["default"];
})();

 })(window);